module.exports = __webpack_public_path__ + "img/ico-pwa.780ebc2.svg";